module.exports = vendor_65419c0f306ecc94e7df;